@use "variables" as *;

.itemDiv {
  width: 100%;
  height: 36px;
  padding-left: $spacing-m;
  padding-right: $spacing-m;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.title {
  font-size: $fontSize-m;
  font-weight: normal;
}

.subtitle {
  font-size: $fontSize-xs !important;
  font-weight: normal !important;
}

.item {
  font-size: $fontSize-s !important;
  font-weight: bold !important;
}
